import { render, staticRenderFns } from "./CrmSolicitantes.vue?vue&type=template&id=b1386394&"
import script from "./CrmSolicitantes.vue?vue&type=script&lang=js&"
export * from "./CrmSolicitantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports